import { useIsKnowledge } from '../../hooks/useIsKnowledge';

export const Terms = () => {
    const { isKnowledge } = useIsKnowledge();
    if (isKnowledge) {
        return (
            <>
                <header className="backdrop-blur border-b border-gray-200 dark:border-gray-800">
                    <div className="max-w-4xl mx-auto px-4 py-3">
                        <div className="flex items-center gap-3">
                            <div>
                                <h1 className="text-xs font-semibold tracking-tight">
                                    Términos y Condiciones de Uso – Mindy – Gestor de Conocimiento
                                </h1>
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                    Última actualización: 3 de marzo de 2026.
                                </p>
                            </div>
                        </div>
                    </div>
                </header>
                <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-4 text-xs text-gray-700 dark:text-gray-300">
                    <section>
                        <h2 className="text-xs font-bold mb-2">1. ACEPTACIÓN Y OBJETO</h2>
                        <p className="mb-2">
                            Los presentes términos y condiciones (los "Términos") regulan el acceso y utilización de
                            Mindy, una herramienta basada en inteligencia artificial provista por QUADMINDS TECHNOLOGIES
                            S.A. y/o sus afiliadas ("QUADMINDS"), por parte de toda persona física o jurídica que acceda
                            o utilice el servicio (el "Cliente").
                        </p>
                        <p className="mb-2">
                            Mindy podrá ser comercializada directamente por QUADMINDS o a través de canales comerciales
                            autorizados (en adelante, el "Partner"). En caso de contratación mediante un Partner, las
                            condiciones comerciales y de facturación podrán regirse por el acuerdo celebrado entre el
                            Cliente y dicho Partner, sin perjuicio de que el acceso y uso del servicio se encuentren
                            sujetos a los presentes Términos.
                        </p>
                        <p className="mb-2">
                            La participación de un Partner en la comercialización no implica relación de representación,
                            agencia ni mandato respecto de QUADMINDS, salvo pacto expreso en contrario.
                        </p>
                        <p className="mb-2">
                            El uso de Mindy implica la aceptación plena, expresa y sin reservas de estos Términos. Si la
                            aceptación se realiza por intermedio de un representante, éste declara contar con facultades
                            suficientes para obligar válidamente al Cliente.
                        </p>
                        <p className="mb-1">Los presentes Términos se integran con:</p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>
                                a) las condiciones comerciales aplicables (celebradas con QUADMINDS o con el partner);
                            </li>
                            <li>b) la Política de Privacidad vigente; y</li>
                            <li>c) cualquier anexo u orden de servicio correspondiente.</li>
                        </ul>
                        <p>
                            En caso de conflicto, las condiciones comerciales prevalecerán exclusivamente respecto de
                            los aspectos económicos o de alcance específicamente acordados.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">2. NATURALEZA DEL SERVICIO Y ALCANCE DE LA LICENCIA</h2>
                        <p className="mb-2">
                            Mindy constituye una herramienta tecnológica de gestión y consulta de conocimiento basada en
                            inteligencia artificial, diseñada para procesar y organizar información proporcionada por el
                            Cliente y generar respuestas automatizadas de carácter informativo.
                        </p>
                        <p className="mb-2">
                            Mindy opera como un servicio independiente y autónomo, no integrado -actualmente- a la
                            Plataforma Quadminds ni a otros sistemas del Cliente, salvo que QUADMINDS lo establezca
                            expresamente mediante acuerdo escrito.
                        </p>
                        <p className="mb-2">
                            La eventual incorporación futura de funcionalidades de integración, conexión con otros
                            sistemas o ampliación de capacidades no constituye obligación contractual alguna para
                            QUADMINDS, salvo pacto expreso y por escrito entre las Partes.
                        </p>
                        <p className="mb-2">
                            Los presentes Términos regulan exclusivamente el uso de Mindy y no modifican ni sustituyen
                            otros acuerdos vigentes entre el Cliente y QUADMINDS.
                        </p>
                        <p className="mb-2">
                            QUADMINDS otorga al Cliente una licencia de uso no exclusiva, limitada, revocable, personal
                            e intransferible, para acceder y utilizar Mindy durante la vigencia contractual y conforme a
                            los alcances del plan contratado, quedando expresamente prohibida su cesión,
                            sublicenciamiento, comercialización o reventa bajo cualquier modalidad.
                        </p>
                        <p>
                            El Cliente reconoce que la contratación del servicio no implica la adquisición de derecho
                            alguno de propiedad intelectual sobre la herramienta, sus desarrollos, mejoras o
                            funcionalidades futuras.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">
                            3. SERVICIOS DE IA – ALCANCE, NATURALEZA Y LIMITACIONES:
                        </h2>
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-xs font-semibold mb-1">
                                    3.1 Naturaleza Informativa y Alcance Funcional:
                                </h3>
                                <p className="mb-2">
                                    Los Servicios de IA prestados a través de Mindy consisten exclusivamente en la
                                    generación automatizada de respuestas, resúmenes, análisis o sugerencias de carácter
                                    informativo (los "Outputs"), a partir de la información proporcionada por el Cliente
                                    y procesada mediante modelos de inteligencia artificial.
                                </p>
                                <p className="mb-1">
                                    Mindy constituye una herramienta de gestión y consulta de conocimiento cuya
                                    finalidad es asistir al Cliente en la organización y recuperación de información. En
                                    ningún caso implica:
                                </p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>ejecución automática de acciones;</li>
                                    <li>modificación, eliminación o alteración de datos;</li>
                                    <li>interacción activa con sistemas externos;</li>
                                    <li>integración con APIs de terceros;</li>
                                    <li>conexión directa con plataformas operativas;</li>
                                    <li>automatización de procesos;</li>
                                    <li>emisión de decisiones autónomas;</li>
                                    <li>
                                        generación de actos con efectos jurídicos, regulatorios, financieros u
                                        operativos;
                                    </li>
                                    <li>sustitución del criterio, validación o revisión humana.</li>
                                </ul>
                                <p className="mb-1">El Cliente reconoce y acepta que los Outputs:</p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>
                                        a) pueden contener errores, omisiones, inexactitudes o sesgos propios de
                                        tecnologías de inteligencia artificial;
                                    </li>
                                    <li>
                                        b) no constituyen asesoramiento profesional, técnico, legal, contable ni
                                        regulatorio;
                                    </li>
                                    <li>
                                        c) no garantizan exhaustividad, actualización permanente ni adecuación a un
                                        propósito específico;
                                    </li>
                                    <li>
                                        d) no sustituyen sistemas formales de archivo, gestión documental, control
                                        interno o compliance.
                                    </li>
                                </ul>
                                <p className="mb-2">
                                    En consecuencia, el Cliente asume la responsabilidad exclusiva de revisar, validar y
                                    verificar los Outputs antes de cualquier utilización o toma de decisión basada en
                                    los mismos.
                                </p>
                                <p>
                                    La eventual incorporación futura de funcionalidades adicionales, integraciones o
                                    capacidades operativas no constituye obligación contractual para QUADMINDS salvo
                                    acuerdo expreso y por escrito entre las Partes.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xs font-semibold mb-1">3.2 Contenido del Cliente</h3>
                                <p className="mb-2">
                                    El Cliente podrá cargar, ingresar o poner a disposición de Mindy información, datos,
                                    documentos o contenidos propios (el "Contenido del Cliente").
                                </p>
                                <p className="mb-1">El Cliente declara y garantiza que:</p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>
                                        a) cuenta con todos los derechos, autorizaciones y bases legales necesarias para
                                        el tratamiento del Contenido del Cliente;
                                    </li>
                                    <li>
                                        b) la carga y tratamiento del Contenido del Cliente no infringe derechos de
                                        terceros ni normativa aplicable;
                                    </li>
                                    <li>c) el Contenido del Cliente es lícito y ha sido obtenido de manera válida.</li>
                                </ul>
                                <p className="mb-2">
                                    El Cliente será el único responsable del cumplimiento de la normativa aplicable en
                                    materia de protección de datos personales, confidencialidad, secreto profesional,
                                    propiedad intelectual y cualquier otra regulación aplicable al Contenido del
                                    Cliente.
                                </p>
                                <p>
                                    QUADMINDS no asume responsabilidad alguna por la carga de información sin base legal
                                    suficiente ni por las consecuencias derivadas del uso de información inexacta,
                                    incompleta o ilícitamente obtenida.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xs font-semibold mb-1">3.3 Acceso y Tratamiento del Contenido</h3>
                                <p className="mb-1">
                                    QUADMINDS no accederá al Contenido del Cliente ni a los Outputs generados, salvo en
                                    los siguientes supuestos:
                                </p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>(i) autorización expresa y documentada del Cliente;</li>
                                    <li>
                                        (ii) cuando dicho acceso resulte estrictamente necesario para la correcta
                                        prestación, mantenimiento o soporte técnico del servicio;
                                    </li>
                                    <li>
                                        (iii) cuando exista obligación legal o requerimiento de autoridad competente.
                                    </li>
                                </ul>
                                <p className="mb-2">
                                    En todos los casos, QUADMINDS adoptará medidas técnicas y organizativas razonables,
                                    acordes a estándares de la industria, para proteger la confidencialidad, integridad
                                    y disponibilidad del Contenido del Cliente.
                                </p>
                                <p>
                                    El acceso eventual por parte de QUADMINDS no implicará adquisición de derecho alguno
                                    de propiedad ni facultad de uso distinto al estrictamente necesario para la
                                    prestación del servicio conforme a estos Términos.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">4. USUARIOS AUTORIZADOS</h2>
                        <p className="mb-2">
                            El acceso y utilización de Mindy estará limitado exclusivamente a aquellas personas físicas
                            que el Cliente designe y habilite formalmente como usuarios autorizados (los "Usuarios
                            Autorizados").
                        </p>
                        <p className="mb-2">
                            La cantidad de Usuarios Autorizados, así como los niveles, perfiles o permisos de acceso
                            asignados a cada uno de ellos, serán determinados conforme a lo establecido en las
                            condiciones comerciales particulares acordadas con el Cliente.
                        </p>
                        <p>
                            QUADMINDS podrá ofrecer distintos niveles de autorización o perfiles funcionales, que podrán
                            incluir —entre otros— permisos diferenciados de consulta, carga de información,
                            administración o configuración, según el plan contratado.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">5. USOS PROHIBIDOS</h2>
                        <p className="mb-1">El Cliente no podrá:</p>
                        <ul className="list-none pl-4 space-y-1">
                            <li>utilizar Mindy con fines ilícitos;</li>
                            <li>introducir virus o afectar la integridad del sistema;</li>
                            <li>realizar ingeniería inversa;</li>
                            <li>intentar extraer lógica, prompts o parámetros del modelo;</li>
                            <li>utilizar la herramienta para desarrollar modelos competidores;</li>
                            <li>realizar extracción masiva automatizada;</li>
                            <li>
                                utilizar Outputs como único fundamento para decisiones críticas sin validación humana.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">7. INTELIGENCIA ARTIFICIAL</h2>
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-xs font-semibold mb-1">
                                    7.1 Naturaleza Tecnológica y Limitaciones
                                </h3>
                                <p className="mb-2">
                                    El Cliente reconoce y acepta que la inteligencia artificial y los sistemas de
                                    aprendizaje automático constituyen tecnologías de carácter probabilístico, evolutivo
                                    y no determinístico, cuyo funcionamiento puede generar resultados variables aun ante
                                    consultas similares.
                                </p>
                                <p className="mb-1">En tal sentido, los Outputs:</p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>
                                        a) pueden contener errores, omisiones, inexactitudes, desactualizaciones o
                                        sesgos;
                                    </li>
                                    <li>
                                        b) pueden resultar incompletos o no reflejar la totalidad de la información
                                        disponible;
                                    </li>
                                    <li>c) no garantizan exactitud factual ni adecuación a un propósito específico;</li>
                                    <li>
                                        d) no constituyen asesoramiento profesional, jurídico, contable, fiscal,
                                        regulatorio ni técnico especializado;
                                    </li>
                                    <li>
                                        e) no implican validación normativa ni cumplimiento automático de regulaciones
                                        aplicables.
                                    </li>
                                </ul>
                                <p className="mb-2">
                                    Mindy se proporciona "tal cual" (as is) y "según disponibilidad" (as available), sin
                                    garantías expresas ni implícitas de ningún tipo.
                                </p>
                                <p>
                                    El Cliente reconoce que los Outputs no sustituyen el análisis, criterio ni
                                    validación humana, y que no deberán utilizarse como único fundamento para la
                                    adopción de decisiones operativas, estratégicas, financieras, contractuales,
                                    regulatorias o de cualquier otra naturaleza que pueda generar consecuencias
                                    jurídicas o económicas.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xs font-semibold mb-1">
                                    7.2 Asunción de Responsabilidad y No Reliance
                                </h3>
                                <p className="mb-1">El Cliente asume la responsabilidad exclusiva por:</p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>a) la evaluación, interpretación y utilización de los Outputs;</li>
                                    <li>b) las decisiones adoptadas sobre la base de los mismos;</li>
                                    <li>c) la verificación de su exactitud antes de cualquier implementación.</li>
                                </ul>
                                <p className="mb-2">
                                    QUADMINDS no será responsable por daños, pérdidas o perjuicios derivados del uso,
                                    interpretación o confianza depositada en los Outputs, salvo en caso de dolo
                                    debidamente probado.
                                </p>
                                <p>
                                    El Cliente reconoce expresamente que el servicio constituye una herramienta de
                                    asistencia informativa y no un sistema de decisión automatizada.
                                </p>
                            </div>
                            <div>
                                <h3 className="text-xs font-semibold mb-1">
                                    7.3 Titularidad, Uso y Entrenamiento de Datos
                                </h3>
                                <p className="mb-2">
                                    El Contenido del Cliente y los Outputs generados específicamente para el Cliente
                                    serán de titularidad exclusiva del Cliente, sin que ello implique cesión alguna de
                                    derechos sobre la tecnología subyacente, algoritmos, modelos, arquitectura o mejoras
                                    desarrolladas por QUADMINDS.
                                </p>
                                <p className="mb-2">
                                    QUADMINDS no utilizará el Contenido del Cliente ni sus Outputs para entrenar modelos
                                    generales de inteligencia artificial ni para fines comerciales ajenos a la
                                    prestación del servicio, salvo consentimiento previo, expreso y por escrito del
                                    Cliente.
                                </p>
                                <p className="mb-1">No obstante lo anterior, QUADMINDS podrá:</p>
                                <ul className="list-none pl-4 space-y-1 mb-2">
                                    <li>
                                        a) utilizar datos agregados, estadísticos y debidamente anonimizados, siempre
                                        que no permitan identificar directa o indirectamente al Cliente o a personas
                                        físicas;
                                    </li>
                                    <li>
                                        b) emplear información técnica derivada del uso del servicio (por ejemplo,
                                        métricas de rendimiento, patrones de uso o logs técnicos) con fines de
                                        seguridad, mejora y optimización del servicio.
                                    </li>
                                </ul>
                                <p>
                                    En ningún caso la utilización de información agregada implicará divulgación de
                                    secretos comerciales, información confidencial o datos personales identificables del
                                    Cliente.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">8. LIMITACIÓN DE RESPONSABILIDAD</h2>
                        <p className="mb-2">
                            En la máxima medida permitida por la legislación aplicable, QUADMINDS no será responsable
                            frente al Cliente ni frente a terceros por daños indirectos, incidentales, especiales,
                            ejemplares, punitivos o consecuenciales; pérdida de ganancias, ingresos, oportunidades de
                            negocio o contratos; pérdida o corrupción de datos; interrupción de actividades comerciales;
                            daño reputacional; costos de reemplazo de servicios o tecnologías; ni por cualquier
                            perjuicio derivado del uso o imposibilidad de uso de Mindy.
                        </p>
                        <p className="mb-2">
                            La presente exclusión aplicará independientemente de la naturaleza del reclamo (contractual,
                            extracontractual, objetiva, subjetiva o de cualquier otra índole), aun cuando QUADMINDS
                            hubiera sido advertida acerca de la posibilidad de tales daños.
                        </p>
                        <p className="mb-2">
                            La responsabilidad total y acumulada de QUADMINDS derivada de los presentes Términos,
                            cualquiera sea la causa del reclamo, estará limitada al monto efectivamente abonado por el
                            Cliente por el servicio Mindy durante los seis (6) meses inmediatamente anteriores al hecho
                            que origine el reclamo.
                        </p>
                        <p className="mb-3">
                            En ningún caso la responsabilidad podrá exceder dicho límite, salvo que la legislación
                            aplicable disponga lo contrario de manera inderogable.
                        </p>
                        <h3 className="text-xs font-semibold mb-1">Exclusiones Específicas Relacionadas con IA</h3>
                        <p className="mb-1">QUADMINDS no será responsable por:</p>
                        <ul className="list-none pl-4 space-y-1 mb-3">
                            <li>a) decisiones adoptadas por el Cliente basadas total o parcialmente en los Outputs;</li>
                            <li>b) errores, omisiones o sesgos propios de tecnologías de inteligencia artificial;</li>
                            <li>c) inexactitudes derivadas del Contenido del Cliente;</li>
                            <li>d) resultados obtenidos a partir de interpretaciones realizadas por el Cliente;</li>
                            <li>e) la falta de adecuación de los Outputs a necesidades específicas del Cliente.</li>
                        </ul>
                        <h3 className="text-xs font-semibold mb-1">Dependencia de Proveedores Tecnológicos</h3>
                        <p className="mb-2">
                            El Cliente reconoce que los Servicios de IA pueden depender, total o parcialmente, de
                            tecnologías, motores de inteligencia artificial, infraestructura de hosting u otros
                            servicios provistos por terceros.
                        </p>
                        <p className="mb-2">
                            QUADMINDS no será responsable por interrupciones, modificaciones, limitaciones funcionales,
                            degradaciones de rendimiento, cambios en las condiciones técnicas o variaciones en los
                            costos o esquemas de pricing derivados de actos, decisiones u omisiones de dichos
                            proveedores, siempre que no medie dolo o culpa grave de QUADMINDS.
                        </p>
                        <p className="mb-2">
                            En caso de que tales cambios impacten materialmente en la prestación del Servicio o en sus
                            costos, QUADMINDS podrá ajustar las condiciones económicas aplicables, previa notificación
                            al Cliente.
                        </p>
                        <p>
                            Las Partes reconocen que las limitaciones de responsabilidad establecidas en la presente
                            cláusula constituyen un elemento esencial del equilibrio económico del contrato y han sido
                            consideradas para la determinación del precio del servicio.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">9. GARANTÍA</h2>
                        <p className="mb-2">
                            Mindy y los Servicios de IA se proporcionan "tal cual" ("as is") y "según disponibilidad"
                            ("as available"), en el estado tecnológico en que se encuentren al momento de su
                            utilización.
                        </p>
                        <p className="mb-2">
                            En la máxima medida permitida por la legislación aplicable, QUADMINDS no otorga garantías de
                            ningún tipo, ya sean expresas, implícitas, legales o de cualquier otra naturaleza,
                            incluyendo —sin limitación— garantías implícitas de comerciabilidad; adecuación para un
                            propósito particular; disponibilidad ininterrumpida; exactitud o confiabilidad de los
                            Outputs; ausencia de errores, defectos, interrupciones o vulnerabilidades; no infracción de
                            derechos de terceros.
                        </p>
                        <p className="mb-2">
                            QUADMINDS no garantiza que el servicio funcionará de manera continua, ininterrumpida o libre
                            de fallas; los defectos serán corregidos en un plazo determinado; el servicio estará libre
                            de virus u otros componentes dañinos; los resultados obtenidos satisfarán expectativas
                            específicas del Cliente.
                        </p>
                        <p className="mb-2">
                            El Cliente reconoce que la disponibilidad del servicio puede verse afectada por tareas de
                            mantenimiento, actualizaciones, mejoras, fallas técnicas, eventos de fuerza mayor o
                            circunstancias ajenas al control razonable de QUADMINDS.
                        </p>
                        <p>
                            En ningún caso la eventual existencia de errores, interrupciones o variaciones en el
                            rendimiento implicará incumplimiento contractual automático, salvo que se hubiera pactado
                            expresamente un nivel de servicio específico por escrito.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">
                            10. EXPORTACIÓN, ELIMINACIÓN Y NO RETENCIÓN DEL CONTENIDO
                        </h2>
                        <p className="mb-2">
                            El Cliente reconoce y acepta que será el único responsable de exportar y/o recuperar su
                            Contenido con anterioridad a la terminación o expiración de los Servicios de IA.
                        </p>
                        <p className="mb-2">
                            A la terminación o expiración de los Servicios de IA, Quadminds procederá a eliminar o
                            anonimizar, de forma inmediata, todo el Contenido almacenado en sus sistemas, incluyendo
                            cualquier copia, respaldo (sujeto a los ciclos habituales de retención) y cualquier dato
                            derivado de dicho Contenido, tales como índices, embeddings o resultados procesados, salvo
                            en la medida en que su conservación resulte exigida por la normativa aplicable.
                        </p>
                        <p className="mb-2">
                            Quadminds no tendrá obligación alguna de conservar, almacenar ni poner a disposición el
                            Contenido con posterioridad a la terminación de los Servicios de IA, y no será responsable
                            por la pérdida de datos que pudiera derivarse de la falta de exportación por parte del
                            Cliente con anterioridad a dicha terminación.
                        </p>
                        <p>
                            El Cliente será responsable de eliminar cualquier dato que se encuentre almacenado en sus
                            propios sistemas o en entornos de terceros no controlados por Quadminds.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">11. PROPIEDAD INTELECTUAL</h2>
                        <p className="mb-2">
                            Todos los derechos de propiedad intelectual e industrial sobre Mindy, incluyendo -sin
                            limitación- su código fuente y objeto, arquitectura, algoritmos, modelos de inteligencia
                            artificial, prompts, bases de datos, interfaces, diseños, documentación, desarrollos,
                            mejoras, actualizaciones y cualquier componente tecnológico subyacente, pertenecen
                            exclusivamente a QUADMINDS y/o a sus terceros licenciantes, según corresponda.
                        </p>
                        <p className="mb-2">
                            El Cliente reconoce que el acceso al servicio no implica cesión, transferencia ni licencia
                            alguna sobre la tecnología subyacente, salvo el derecho limitado de uso expresamente
                            otorgado en estos Términos.
                        </p>
                        <p className="mb-1">En virtud de lo anterior:</p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>
                                a) el Cliente adquiere únicamente un derecho de uso no exclusivo, limitado, revocable,
                                intransferible y no sublicenciable para utilizar Mindy durante la vigencia contractual y
                                conforme al plan contratado;
                            </li>
                            <li>
                                b) no adquiere derecho alguno sobre el código fuente, modelos, algoritmos, desarrollos
                                derivados, mejoras futuras ni funcionalidades adicionales;
                            </li>
                            <li>
                                c) no podrá modificar, adaptar, descompilar, realizar ingeniería inversa, reproducir,
                                distribuir ni crear obras derivadas de Mindy;
                            </li>
                            <li>
                                d) no podrá utilizar el servicio para desarrollar productos o servicios competidores.
                            </li>
                        </ul>
                        <p className="mb-2">
                            Las mejoras, desarrollos, adaptaciones o funcionalidades que QUADMINDS incorpore a Mindy,
                            aun cuando se basen en sugerencias, comentarios o retroalimentación del Cliente, serán de
                            exclusiva titularidad de QUADMINDS, sin que ello genere derecho de compensación o
                            participación alguna a favor del Cliente.
                        </p>
                        <p>
                            Nada de lo dispuesto en estos Términos se interpretará como concesión implícita de derechos
                            distintos a los expresamente establecidos.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">12. PROTECCIÓN DE DATOS PERSONALES</h2>
                        <p className="mb-2">
                            En el marco de los presentes Términos, el Cliente actuará como responsable del tratamiento
                            respecto de todos los datos personales que incorpore, cargue o ponga a disposición a través
                            de Mindy.
                        </p>
                        <p className="mb-2">
                            QUADMINDS actuará exclusivamente como encargado del tratamiento, y únicamente en la medida
                            en que deba acceder, almacenar o procesar datos personales por cuenta del Cliente y conforme
                            a instrucciones documentadas de este, con el único propósito de prestar los Servicios de IA.
                        </p>
                        <p className="mb-1">El Cliente declara y garantiza que:</p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>
                                a) cuenta con una base legal válida para el tratamiento de los datos personales
                                incorporados en Mindy;
                            </li>
                            <li>
                                b) ha obtenido las autorizaciones, consentimientos o habilitaciones necesarias cuando
                                correspondan;
                            </li>
                            <li>
                                c) ha informado adecuadamente a los titulares de los datos sobre el tratamiento
                                realizado;
                            </li>
                            <li>
                                d) el tratamiento realizado a través de Mindy cumple con la normativa aplicable en
                                materia de protección de datos personales en la jurisdicción correspondiente.
                            </li>
                        </ul>
                        <p className="mb-2">
                            QUADMINDS no será responsable por el origen, licitud, exactitud ni legitimidad de los datos
                            personales incorporados por el Cliente.
                        </p>
                        <p className="mb-1">
                            El Cliente mantendrá indemne y defenderá a QUADMINDS frente a cualquier reclamo, sanción,
                            multa, procedimiento administrativo o judicial, daño o perjuicio derivado de:
                        </p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>la falta de base legal suficiente para el tratamiento;</li>
                            <li>el incumplimiento de obligaciones regulatorias por parte del Cliente;</li>
                            <li>la carga de datos sin autorización válida;</li>
                            <li>o el tratamiento ilícito de datos personales por parte del Cliente.</li>
                        </ul>
                        <p>
                            Las obligaciones precedentes subsistirán aun después de la terminación del servicio,
                            respecto de tratamientos realizados durante la vigencia contractual.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">13. CONFIDENCIALIDAD</h2>
                        <p className="mb-2">
                            Las Partes acuerdan que toda información confidencial intercambiada en el marco de la
                            negociación, celebración y ejecución de los presentes Términos (la "Información
                            Confidencial") deberá mantenerse estrictamente confidencial.
                        </p>
                        <p className="mb-1">
                            A los efectos de la presente cláusula, se considerará Información Confidencial toda
                            información, ya sea técnica, comercial, financiera, operativa, estratégica o de cualquier
                            otra naturaleza, divulgada por una Parte a la otra, por cualquier medio, incluyendo -sin
                            limitación-:
                        </p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>datos, documentos y contenidos cargados en Mindy;</li>
                            <li>especificaciones técnicas, arquitectura, modelos y desarrollos tecnológicos;</li>
                            <li>información comercial, listas de clientes, precios y propuestas;</li>
                            <li>know-how, secretos comerciales y estrategias;</li>
                            <li>credenciales de acceso y configuraciones del sistema.</li>
                        </ul>
                        <p className="mb-1">La Parte receptora se obliga a:</p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>
                                a) utilizar la Información Confidencial exclusivamente para el cumplimiento de los
                                presentes Términos;
                            </li>
                            <li>
                                b) no divulgarla a terceros sin autorización previa y escrita de la Parte reveladora;
                            </li>
                            <li>
                                c) limitar su acceso únicamente a empleados, asesores o contratistas que necesiten
                                conocerla para la ejecución del servicio y que se encuentren sujetos a obligaciones de
                                confidencialidad equivalentes;
                            </li>
                            <li>
                                d) adoptar medidas técnicas y organizativas razonables para protegerla contra acceso,
                                uso o divulgación no autorizada.
                            </li>
                        </ul>
                        <p className="mb-1">
                            Las obligaciones de confidencialidad no serán aplicables respecto de información que:
                        </p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>(i) sea de dominio público sin violación de esta cláusula;</li>
                            <li>
                                (ii) obre legítimamente en poder de la Parte receptora con anterioridad a su
                                divulgación;
                            </li>
                            <li>
                                (iii) haya sido obtenida legítimamente de un tercero sin obligación de confidencialidad;
                            </li>
                            <li>
                                (iv) deba ser revelada por obligación legal o requerimiento de autoridad competente, en
                                cuyo caso la Parte receptora notificará previamente a la Parte reveladora cuando ello
                                sea legalmente posible.
                            </li>
                        </ul>
                        <p className="mb-2">
                            Las obligaciones establecidas en la presente cláusula permanecerán vigentes durante la
                            vigencia contractual y por un plazo de dos (2) años contados desde su terminación,
                            cualquiera sea la causa.
                        </p>
                        <p className="mb-2">
                            No obstante lo anterior, respecto de secretos comerciales, know-how tecnológico, algoritmos,
                            modelos de inteligencia artificial y demás información cuya naturaleza exija protección
                            prolongada, la obligación de confidencialidad subsistirá mientras dicha información conserve
                            carácter confidencial.
                        </p>
                        <p>
                            A la terminación de la relación contractual, cada Parte deberá, a solicitud de la otra,
                            devolver o destruir la Información Confidencial recibida, salvo aquella cuya conservación
                            resulte exigida por normativa aplicable.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">14. MODIFICACIONES</h2>
                        <p className="mb-2">
                            QUADMINDS podrá modificar, actualizar o reemplazar los presentes Términos cuando resulte
                            necesario por razones técnicas, operativas, comerciales, regulatorias o de evolución del
                            servicio.
                        </p>
                        <p className="mb-2">
                            Las modificaciones serán publicadas en la plataforma Mindy y/o notificadas al Cliente por
                            medios electrónicos a las direcciones de contacto informadas.
                        </p>
                        <p className="mb-2">
                            Salvo que la modificación establezca una fecha distinta, los cambios entrarán en vigor a los
                            quince (15) días corridos desde su notificación.
                        </p>
                        <p className="mb-2">
                            En caso de que el Cliente no estuviera de acuerdo con las modificaciones sustanciales
                            introducidas, podrá comunicar su objeción por escrito antes de su entrada en vigencia y
                            resolver el contrato sin penalidad dentro del plazo indicado.
                        </p>
                        <p className="mb-2">
                            La continuidad en el uso del servicio con posterioridad a la entrada en vigor de las
                            modificaciones implicará aceptación plena de los nuevos Términos.
                        </p>
                        <p>
                            No obstante lo anterior, las modificaciones que resulten necesarias para cumplir
                            obligaciones legales, regulatorias o requerimientos de autoridad competente podrán entrar en
                            vigencia inmediata.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">15. SUSPENSIÓN Y TERMINACIÓN</h2>
                        <p className="mb-1">
                            QUADMINDS podrá suspender temporalmente o cancelar definitivamente el acceso del Cliente y/o
                            de sus Usuarios Autorizados a Mindy, total o parcialmente, en los siguientes supuestos:
                        </p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>
                                a) incumplimiento de los presentes Términos o de las condiciones comerciales aplicables;
                            </li>
                            <li>
                                b) uso indebido del servicio, incluyendo violaciones a la normativa vigente o a derechos
                                de terceros;
                            </li>
                            <li>
                                c) utilización que genere riesgos razonables para la seguridad, integridad o estabilidad
                                técnica de Mindy o de la infraestructura asociada;
                            </li>
                            <li>
                                d) detección de accesos no autorizados o vulneraciones de seguridad atribuibles al
                                Cliente;
                            </li>
                            <li>e) falta de pago conforme a las condiciones comerciales acordadas;</li>
                            <li>
                                f) obligación legal, requerimiento de autoridad competente o cumplimiento regulatorio;
                            </li>
                            <li>g) supuestos de fuerza mayor o caso fortuito;</li>
                            <li>
                                h) circunstancias técnicas que comprometan razonablemente la continuidad, estabilidad o
                                seguridad del servicio.
                            </li>
                        </ul>
                        <p className="mb-2">
                            Asimismo, QUADMINDS podrá, a su exclusivo criterio y por razones técnicas, operativas o
                            comerciales, discontinuar, modificar o limitar total o parcialmente Mindy, incluyendo la
                            suspensión, desactivación o sustitución de determinados módulos, herramientas o
                            funcionalidades de inteligencia artificial, cuando ello resulte necesario para preservar la
                            integridad del servicio, adaptarlo a cambios tecnológicos o a condiciones o limitaciones
                            impuestas por proveedores terceros.
                        </p>
                        <p className="mb-2">
                            Salvo en casos de urgencia, riesgo inminente o requerimiento legal, QUADMINDS procurará
                            notificar previamente al Cliente y otorgar un plazo razonable para subsanar el
                            incumplimiento cuando ello resulte posible.
                        </p>
                        <p className="mb-2">
                            La suspensión preventiva no implicará renuncia a otros derechos contractuales ni generará
                            responsabilidad para QUADMINDS cuando se encuentre fundada en los supuestos aquí previstos.
                        </p>
                        <p>
                            En caso de cancelación definitiva por incumplimiento imputable al Cliente, QUADMINDS podrá
                            resolver el contrato sin derecho a reembolso alguno.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">16. NATURALEZA EVOLUTIVA DE LA TECNOLOGÍA</h2>
                        <p className="mb-2">
                            El Cliente reconoce y acepta que los sistemas de inteligencia artificial constituyen
                            tecnologías dinámicas, evolutivas y en constante desarrollo, cuyo funcionamiento puede
                            experimentar ajustes, mejoras, modificaciones o variaciones a lo largo del tiempo.
                        </p>
                        <p className="mb-1">En consecuencia:</p>
                        <ul className="list-none pl-4 space-y-1 mb-2">
                            <li>a) el rendimiento, precisión, formato o estilo de los Outputs podrá variar;</li>
                            <li>
                                b) determinadas funcionalidades podrán ser modificadas, actualizadas, reemplazadas o
                                discontinuadas;
                            </li>
                            <li>
                                c) podrán incorporarse mejoras, cambios técnicos o ajustes en la arquitectura del
                                servicio;
                            </li>
                            <li>
                                d) podrán producirse comportamientos no previstos propios de sistemas basados en modelos
                                probabilísticos.
                            </li>
                        </ul>
                        <p className="mb-2">
                            Tales modificaciones o variaciones no constituirán incumplimiento contractual ni darán
                            derecho a reclamo, indemnización o resolución, siempre que no impliquen una alteración
                            sustancial del objeto principal del servicio contratado.
                        </p>
                        <p>
                            El Cliente reconoce que la evolución tecnológica es parte inherente del servicio y que la
                            prestación no implica la garantía de mantenimiento indefinido de funcionalidades
                            específicas, salvo que ello haya sido expresamente pactado por escrito.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xs font-bold mb-2">17. LEY APLICABLE Y JURISDICCIÓN</h2>
                        <p className="mb-2">
                            Los presentes Términos, su interpretación, validez, ejecución y cumplimiento se regirán
                            exclusivamente por las leyes de la República Argentina, con exclusión de sus normas sobre
                            conflicto de leyes.
                        </p>
                        <p className="mb-2">
                            Toda controversia, reclamo o disputa derivada de los presentes Términos, su existencia,
                            interpretación, alcance, cumplimiento o terminación, será sometida a la jurisdicción
                            exclusiva de los Tribunales Ordinarios con asiento en la Ciudad Autónoma de Buenos Aires,
                            renunciando las Partes a cualquier otro fuero o jurisdicción que pudiera corresponderles,
                            incluso el federal.
                        </p>
                        <p>
                            La presente cláusula se aplicará sin perjuicio de las medidas cautelares o acciones urgentes
                            que pudieran solicitarse ante tribunales competentes cuando ello resulte necesario para la
                            protección de derechos.
                        </p>
                    </section>
                </main>
            </>
        );
    }

    return (
        <>
            <header className="backdrop-blur border-b border-gray-200 dark:border-gray-800">
                <div className="max-w-4xl mx-auto px-4 py-3">
                    <div className="flex items-center gap-3">
                        <div>
                            <h1 className="text-xs font-semibold tracking-tight">
                                Términos y Condiciones de Uso – Mindy
                            </h1>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                                Última actualización: 2 de octubre de 2025
                            </p>
                        </div>
                    </div>
                </div>
            </header>
            <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 space-y-4 text-xs text-gray-700 dark:text-gray-300">
                <section>
                    <h2 className="text-xs font-bold mb-2">1. ACEPTACIÓN Y OBJETO:</h2>
                    <p className="mb-2">
                        Los presentes términos y condiciones (en adelante, los "Términos") regulan el acceso y
                        utilización de Mindy, un agente de inteligencia artificial provisto por QUADMINDS TECHNOLOGIES
                        S.A. y/o sus afiliadas (en adelante, "QUADMINDS"), por parte de toda persona física o jurídica
                        que acceda a Mindy y/o utilice el servicio descripto en el presente (en adelante, el "Cliente").
                    </p>
                    <p className="mb-2">
                        El uso de Mindy requiere la aceptación plena, expresa y sin reservas de estos Términos. En caso
                        de que el acceso se realice por medio de un representante, el mismo declara y garantiza contar
                        con facultades suficientes para obligar legalmente al Cliente. La falta de conformidad con
                        cualquiera de las disposiciones aquí establecidas impide el acceso y utilización de Mindy.
                    </p>
                    <p>
                        Estos Términos se complementan con las condiciones comerciales particulares aceptadas por el
                        Cliente en cada contratación. Asimismo, en los casos en que QUADMINDS ofrezca, a su sola
                        discreción, una versión de prueba de Mindy, su uso quedará igualmente sujeto a lo aquí dispuesto
                        y a las condiciones específicas que QUADMINDS establezca y comunique para dicho acceso temporal.
                    </p>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">2. INTEGRACIÓN CON LA PLATAFORMA QUADMINDS:</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-xs font-semibold mb-1">2.1.</h3>
                            <p className="mb-2">
                                Mindy ha sido concebida como un complemento inteligente de la Plataforma Quadminds de
                                TMS de Distribución (en adelante, la "Plataforma Quadminds") y/o de cualquier otro
                                producto que se incorpore en el futuro, con la finalidad de potenciar y optimizar la
                                experiencia del Cliente en su utilización, conforme lo descripto en el presente.
                            </p>
                            <p className="mb-2">
                                Estos Términos se limitan al uso de Mindy y no sustituyen, modifican, ni derogan los
                                términos y condiciones particulares previamente aceptados por el Cliente al contratar la
                                Plataforma Quadminds, los cuales mantienen plena vigencia y aplicabilidad en lo que
                                corresponda.
                            </p>
                            <p>
                                El Cliente comprende que Mindy se integrará exclusivamente con la cuenta creada por el
                                Cliente para la contratación de la Plataforma Quadminds (en adelante, la "Cuenta del
                                Cliente"), sin posibilidad de acceso, conexión o interacción con cuentas de terceros,
                                sistemas externos o fuentes de información ajenas.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">2.2.</h3>
                            <p>
                                El acceso a Mindy se otorga al CLIENTE en carácter no exclusivo, limitado, personal e
                                intransferible, quedando expresamente prohibida su cesión, sublicenciamiento,
                                comercialización o reventa a terceros bajo cualquier modalidad.
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">3. VERSIÓN DE PRUEBA:</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-xs font-semibold mb-1">3.1.</h3>
                            <p>
                                En caso de que el CLIENTE acceda a Mindy mediante una versión de prueba, dicho acceso
                                tendrá como única finalidad permitir su evaluación a efectos de considerar su eventual
                                contratación en modalidad comercial. La duración del período de prueba será determinada
                                por QUADMINDS, quien podrá, a su exclusivo criterio, prorrogar o darlo por concluido en
                                cualquier momento. Durante dicho período, el uso de Mindy podrá estar sujeto a
                                restricciones en cuanto al volumen de operaciones, funcionalidades habilitadas,
                                capacidad de almacenamiento y/o demás condiciones técnicas que QUADMINDS disponga.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">3.2.</h3>
                            <p>
                                Finalizado el período de prueba, el acceso del CLIENTE a Mindy será automáticamente
                                suspendido, salvo que el CLIENTE suscriba un plan comercial vigente conforme a las
                                tarifas y condiciones comunicadas por QUADMINDS.
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">4. SERVICIOS DE IA – ALCANCE Y USO.</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-xs font-semibold mb-1">4.1.</h3>
                            <p>
                                Los servicios provistos por Mindy (los "Servicios de IA") tienen como finalidad
                                interpretar, analizar y procesar la información vinculada a las operaciones logísticas
                                del Cliente registradas en la cuenta del Cliente en la Plataforma Quadminds (la "Cuenta
                                del Cliente"), generando de manera automatizada respuestas y contenidos (los "Outputs")
                                frente a las consultas formuladas por el propio Cliente o sus Usuarios Autorizados
                                (definidos más abajo), dentro del alcance y limitaciones previstos en los presentes
                                Términos.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">4.2.</h3>
                            <p className="mb-2">
                                De forma adicional, el Cliente podrá cargar, subir o ingresar directamente documentos,
                                datos e información interna ("Contenido del Cliente") con el fin de que Mindy los
                                procese y genere Outputs relacionados. El Contenido del Cliente deberá cumplir con los
                                formatos, restricciones y especificaciones técnicas que QUADMINDS defina en su
                                documentación oficial.
                            </p>
                            <p>
                                El CLIENTE declara y garantiza que cuenta con todos los derechos, autorizaciones y
                                legitimaciones necesarias sobre el Contenido del Cliente para su uso a través de Mindy.
                                Se recomienda al CLIENTE abstenerse de cargar información confidencial o sensible,
                                incluyendo, a título ejemplificativo, datos personales, financieros o de sus propios
                                clientes.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">4.3.</h3>
                            <p>
                                QUADMINDS no accede al Contenido del Cliente, o a sus Outputs, salvo: (i) autorización
                                expresa del CLIENTE; o (ii) que dicho acceso resulte estrictamente necesario para la
                                correcta prestación de los Servicios de IA, o para otros fines expresamente previstos en
                                los presentes Términos.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">4.4.</h3>
                            <p>
                                En el marco de los Servicios de IA, el CLIENTE reconoce y acepta que Mindy no accede a
                                datos externos ni a funcionalidades distintas de las incluidas en el plan contratado, y
                                que no ejecuta acciones dentro de la Plataforma Quadminds ni adopta decisiones
                                automatizadas que produzcan efectos directos sobre la Cuenta del Cliente, sus sistemas,
                                procesos o servicios.
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">5. USUARIOS AUTORIZADOS.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">5.1.</span> La cantidad de usuarios autorizados para acceder
                            y utilizar Mindy ("Usuarios Autorizados") será determinada por QUADMINDS, o en su defecto
                            establecida en las condiciones comerciales acordadas con el Cliente.
                        </p>
                        <p>
                            <span className="font-semibold">5.2.</span> Cada Usuario Autorizado deberá estar
                            identificado mediante una dirección de correo electrónico y un nombre de usuario únicos, y
                            contará con credenciales de acceso personales e intransferibles ("Credenciales"), las cuales
                            deberán ser modificadas obligatoriamente al momento del primer acceso.
                        </p>
                        <p>
                            <span className="font-semibold">5.3.</span> Queda expresamente prohibido que dos o más
                            personas utilicen de forma simultánea o alternada una misma cuenta de Usuario Autorizado.
                        </p>
                        <p>
                            <span className="font-semibold">5.4.</span> El CLIENTE será el único responsable por todas
                            las acciones u omisiones realizadas a través de las cuentas de sus Usuarios Autorizados, con
                            independencia de que tales actos hayan sido autorizados o no, y deberá adoptar las medidas
                            necesarias para garantizar la confidencialidad, custodia y correcto uso de las Credenciales.
                        </p>
                        <p>
                            <span className="font-semibold">5.5.</span> Quadminds se reserva el derecho de suspender o
                            cancelar, de forma temporal o definitiva, el acceso a cualquier Usuario Autorizado que
                            incumpla las presentes condiciones o haga un uso indebido de la Plataforma.
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">6. LIMITACIONES.</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-xs font-semibold mb-1">
                                6.1. Al utilizar Mindy, el Cliente acuerda que:
                            </h3>
                            <ul className="list-none pl-4 space-y-2">
                                <li>
                                    (i) No utilizará Mindy con fines ilícitos, ilegales, contrarios a lo establecido en
                                    los presentes Términos, a la buena fe y al orden público, lesivos de los derechos e
                                    intereses de terceros;
                                </li>
                                <li>
                                    (ii) No tratará de dañar a Mindy de ningún modo, ni accederá a recursos restringidos
                                    de Mindy;
                                </li>
                                <li>(iii) No utilizará Mindy con un dispositivo incompatible o no autorizado;</li>
                                <li>
                                    (iv) No introducirá ni difundirá virus informáticos o cualesquiera otros sistemas
                                    físicos o lógicos que sean susceptibles de provocar daños Mindy.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">6.2.</h3>
                            <p>
                                En el supuesto en que QUADMINDS considere a su exclusivo criterio que el Cliente se
                                encuentra realizando cualquiera de las actividades mencionadas en la Cláusula anterior,
                                QUADMINDS se reserva el derecho a dar de baja la cuenta del cliente y reclamar por los
                                daños y perjuicios que ello pudiera ocasionar.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">6.3.</h3>
                            <p>
                                El Cliente y cada Usuario Autorizado son los únicos responsables de la información
                                proporcionada a través de Mindy, así como de la Plataforma Quadminds, incluyendo su
                                exactitud y veracidad.
                            </p>
                        </div>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">7. INTELIGENCIA ARTIFICIAL.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">7.1.</span> El CLIENTE reconoce y acepta que la inteligencia
                            artificial y el aprendizaje automático son tecnologías en constante desarrollo y
                            perfeccionamiento. En tal sentido, QUADMINDS se compromete a realizar esfuerzos razonables,
                            conforme a los estándares del sector, para mejorar continuamente la solución Mindy con el
                            fin de que los Outputs sean más precisos, confiables, seguros y útiles para el Cliente. Sin
                            perjuicio de lo anterior, el Cliente entiende y acepta que QUADMINDS no garantiza que los
                            Outputs estén libres de errores, alucinaciones, omisiones, inexactitudes o sesgos, ni asume
                            responsabilidad alguna por su veracidad, completitud o adecuación para un propósito
                            determinado. Los Outputs se proporcionan "tal cual" (as is), sin garantías expresas o
                            implícitas de ningún tipo, incluidas —pero no limitadas a— las garantías de comerciabilidad,
                            adecuación para un propósito particular o no infracción de derechos de terceros. El CLIENTE
                            reconoce que Mindy es un agente de inteligencia artificial y que sus Outputs no constituyen
                            asesoramiento profesional, técnico ni jurídico.
                        </p>
                        <p>
                            <span className="font-semibold">7.2.</span> El Cliente reconoce asimismo que es su
                            responsabilidad exclusiva revisar, validar y, en su caso, complementar o corregir los
                            Outputs generados, y que QUADMINDS no será responsable por daños, perjuicios o cualquier
                            tipo de responsabilidad derivados del uso, interpretación o confianza en dichos Outputs.
                            Asimismo, el Cliente reconoce que la calidad, pertinencia y utilidad de los Outputs podrán
                            depender directa y sustancialmente de la veracidad, precisión, actualidad, completitud y
                            suficiencia de los datos, documentos e información que sean suministrados, cargados o
                            puestos a disposición de Mindy por el propio Cliente, sus Usuarios Autorizados o por
                            terceros bajo su responsabilidad. En consecuencia, cualquier error, omisión o falta de
                            claridad en dicha información podrá afectar de forma directa la calidad o idoneidad de los
                            Outputs, sin que ello genere responsabilidad alguna para QUADMINDS.
                        </p>
                        <p>
                            <span className="font-semibold">7.3.</span> QUADMINDS reconoce y acepta que todos los
                            contenidos, documentos, datos, textos, archivos e información que sea cargado, introducido,
                            proporcionado por el CLIENTE en Mindy, así como los Outputs correspondientes a cada Cliente,
                            son y continuarán siendo de titularidad exclusiva del Cliente, sin que QUADMINDS adquiera
                            sobre ellos derecho alguno de propiedad, titularidad o uso, salvo en la medida expresamente
                            autorizada en estos Términos. QUADMINDS no utilizará la información ni los Outputs del
                            Cliente para fines distintos a los aquí pactados, en la medida en que ello resulte necesario
                            para optimizar la prestación de los Servicios de IA, garantizando en todo momento su
                            confidencialidad y seguridad.
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">8. LIMITACIÓN DE RESPONSABILIDAD.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">8.1.</span> QUADMINDS no se responsabiliza por problemas
                            derivados del uso incorrecto de Mindy. En ningún caso QUADMINDS, su casa matriz, filiales,
                            licenciantes, directores, empleados, agentes o empresas vinculadas serán responsables frente
                            al Cliente y/o al Usuario Autorizado por daños incidentales, indirectos, especiales,
                            punitivos o consecuenciales, ni por pérdidas de beneficios, ingresos, mercadería,
                            oportunidades comerciales o cualquier otro tipo de perjuicio, ya sea previsibles o no,
                            derivados del uso o la imposibilidad de uso de Mindy, independientemente de la causa o del
                            origen del reclamo, incluso si se hubiese advertido sobre la posibilidad de tales daños. El
                            límite máximo de responsabilidad de QUADMINDS por cualquier incumplimiento de los Términos
                            será del monto efectivamente abonado por el Cliente durante los últimos tres (3) meses
                            previos al reclamo, independientemente de la naturaleza del reclamo, salvo que se estipule
                            lo contrario en la legislación aplicable.
                        </p>
                        <p>
                            <span className="font-semibold">8.2.</span> Será responsabilidad del Cliente el uso y
                            resguardo de la cuenta. El Cliente será responsable por el tercero al cual le permitió el
                            acceso.
                        </p>
                        <p>
                            <span className="font-semibold">8.3.</span> Las renuncias y limitaciones expresadas en este
                            acuerdo se aplicarán en la medida máxima permitida por la ley aplicable
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">9. GARANTÍA.</h2>
                    <p className="font-bold uppercase mb-2">
                        EL CLIENTE RECONOCE Y ACEPTA QUE MINDY Y LOS SERVICIOS DE IA SE PROPORCIONAN "TAL CUAL" Y "SEGÚN
                        DISPONIBILIDAD", ÚNICAMENTE EN EL CONTEXTO DE LA RELACIÓN COMERCIAL EXISTENTE ENTRE EL CLIENTE Y
                        QUADMINDS EN RELACIÓN CON MINDY Y LOS SERVICIOS DE IA.
                    </p>
                    <p className="font-bold uppercase mb-2">
                        EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEGISLACIÓN APLICABLE, QUADMINDS NO OTORGA NINGUNA
                        GARANTÍA, EXPRESA O IMPLÍCITA, INCLUYENDO, SIN LIMITARSE A ELLO, GARANTÍAS IMPLÍCITAS DE
                        COMERCIABILIDAD, NO INFRACCIÓN DE DERECHOS DE TERCEROS, CALIDAD SATISFACTORIA O IDONEIDAD PARA
                        UN PROPÓSITO PARTICULAR, ASÍ COMO CUALESQUIERA OTRAS GARANTÍAS QUE PUDIERAN DERIVARSE DE LA LEY,
                        USO O COSTUMBRE COMERCIAL.
                    </p>
                    <p className="font-bold uppercase">
                        QUADMINDS NO GARANTIZA LA DISPONIBILIDAD, CONTINUIDAD NI INFALIBILIDAD DEL FUNCIONAMIENTO DE
                        MINDY O DE LOS SERVICIOS DE IA, NI ASEGURA QUE LA MISMA ESTÉ LIBRE DE ERRORES, INTERRUPCIONES,
                        FALLAS TÉCNICAS O RETRASOS.
                    </p>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">10. DERECHOS DE PROPIEDAD INTELECTUAL.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">10.1.</span> El Cliente, reconoce y acepta que todos los
                            derechos de propiedad intelectual e industrial sobre los contenidos y/o cualesquiera otros
                            elementos insertados en Mindy (incluyendo, sin limitación, marcas, logotipos, nombres
                            comerciales, textos, imágenes, gráficos, diseños, sonidos, bases de datos, software,
                            diagramas de flujo, presentación, audio y vídeo), pertenecen a QUADMINDS y/o sus compañías
                            afiliadas y/o de terceros bajo licencia. En particular, el CLIENTE reconoce que Mindy se
                            encuentra soportada en parte por motores de inteligencia artificial provistos por terceros
                            (por ejemplo, Gemini), cuyos derechos de propiedad intelectual pertenecen a sus respectivos
                            titulares, y cuyo uso por parte de QUADMINDS se realiza en virtud de licencias o
                            autorizaciones válidas. Dicho reconocimiento no implica la concesión de derechos adicionales
                            al CLIENTE sobre tales tecnologías de terceros.
                        </p>
                        <p>
                            <span className="font-semibold">10.2.</span> QUADMINDS y/o sus compañías afiliadas conservan
                            todos los derechos de propiedad intelectual, industrial o aquella que le pudiere
                            corresponder sobre Mindy y respecto de cualquier modificación, actualización, derivado y/o
                            mejora que se le aplique o se realice a Mindy en el futuro.
                        </p>
                        <p>
                            <span className="font-semibold">10.3.</span> El Cliente debe abstenerse de modificar,
                            alterar, reproducir, traducir, copiar con o sin fines de lucro, a Mindy, y se compromete a
                            tomar las medidas internas necesarias y precauciones tendientes a la protección de las
                            mismas, incluyendo, pero no limitado, a evitar cualquier uso no autorizado de la misma.
                        </p>
                        <p>
                            <span className="font-semibold">10.4.</span> El Cliente adquiere únicamente el derecho de
                            usar Mindy, de conformidad con los términos y condiciones aquí estipulados, sin que ello
                            implique en ninguna medida la adquisición por parte del Cliente o los Usuarios Autorizados
                            de derecho alguno de propiedad o título sobre Mindy y demás derechos de propiedad
                            intelectual o industrial de QUADMINDS.
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">11. PROTECCIÓN DE DATOS PERSONALES.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">11.1.</span> El tratamiento de los datos personales del
                            Cliente y/o de sus Usuarios Autorizados se regirá por la Política de Privacidad de
                            QUADMINDS, disponible en el siguiente{' '}
                            <a
                                target="_blank"
                                href="https://www.quadminds.com/politica-de-privacidad-mindy"
                                className="text-blue-500 underline"
                                rel="noreferrer"
                            >
                                enlace
                            </a>
                            , la cual forma parte integrante de los presentes Términos.
                        </p>
                        <p>
                            <span className="font-semibold">11.2.</span> En el marco de estos Términos, las Partes
                            reconocen que todo dato personal que sea cargado, introducido o tratado a través de Mindy
                            será responsabilidad exclusiva del Cliente, en su carácter de responsable del tratamiento.
                        </p>
                        <p>
                            <span className="font-semibold">11.3.</span> QUADMINDS actuará únicamente como encargado del
                            tratamiento en la medida en que deba acceder, almacenar o procesar datos personales por
                            cuenta del Cliente, y exclusivamente con el propósito de prestar los Servicios de IA
                            conforme a lo estipulado en estos Términos.
                        </p>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">
                                11.4. En dicho carácter, QUADMINDS se compromete a:
                            </h3>
                            <ul className="list-none pl-4 space-y-2">
                                <li>
                                    a) tratar los datos personales conforme a instrucciones documentadas del Cliente y
                                    únicamente para los fines aquí previstos;
                                </li>
                                <li>
                                    b) implementar medidas técnicas y organizativas adecuadas para garantizar la
                                    confidencialidad, integridad y seguridad de los datos personales;
                                </li>
                                <li>
                                    c) no comunicar, ceder ni transferir datos personales a terceros, salvo (i) en
                                    cumplimiento de una obligación legal o requerimiento de autoridad competente, (ii)
                                    cuando medie autorización expresa del Cliente, o (iii) cuando sea estrictamente
                                    necesario para la prestación de los Servicios de IA y bajo condiciones contractuales
                                    que aseguren un nivel de protección adecuado;
                                </li>
                                <li>
                                    d) asistir al Cliente, en la medida de lo posible, para el cumplimiento de sus
                                    obligaciones legales en materia de protección de datos personales; y
                                </li>
                                <li>
                                    e) suprimir o devolver los datos personales una vez concluida la prestación de los
                                    Servicios de IA, salvo obligación legal de conservarlos.
                                </li>
                            </ul>
                        </div>
                        <p>
                            <span className="font-semibold">11.5.</span> El Cliente declara y garantiza que cuenta con
                            las bases legales y autorizaciones necesarias para el tratamiento de los datos personales
                            que sean incorporados en Mindy, manteniendo indemne a QUADMINDS frente a cualquier reclamo
                            de terceros por incumplimientos a la normativa de protección de datos.
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">12. CONFIDENCIALIDAD.</h2>
                    <div className="space-y-4">
                        <p>
                            <span className="font-semibold">12.1.</span> En el marco de los presentes Términos,
                            QUADMINDS y el Cliente podrán intercambiar información de carácter confidencial (en
                            adelante, la "Información Confidencial").
                        </p>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">
                                12.2. En tales casos, cada Parte se obliga a:
                            </h3>
                            <ul className="list-none pl-4 space-y-2">
                                <li>
                                    a) adoptar las medidas necesarias para evitar la reproducción, divulgación o uso no
                                    autorizado de la Información Confidencial de la otra Parte, con un nivel de cuidado
                                    al menos equivalente al que emplea para proteger su propia información confidencial;
                                </li>
                                <li>
                                    b) limitar el acceso a la Información Confidencial únicamente a aquellos
                                    administradores, empleados, contratistas, representantes, agentes, asesores y/o
                                    afiliadas que necesiten conocerla para el cumplimiento de los presentes Términos
                                    (los "Representantes");
                                </li>
                                <li>
                                    c) informar a sus Representantes acerca del carácter confidencial de la información
                                    y exigirles el cumplimiento de las obligaciones previstas en esta cláusula;
                                </li>
                                <li>
                                    d) no utilizar la Información Confidencial en beneficio propio ni de terceros, salvo
                                    para los fines previstos en los presentes Términos;
                                </li>
                                <li>
                                    e) cesar inmediatamente el uso de la Información Confidencial en caso de terminación
                                    de la relación contractual, procediendo a devolver o destruir todo material que la
                                    contenga, e instruyendo a sus Representantes y demás involucrados a hacer lo mismo.
                                </li>
                            </ul>
                        </div>
                        <p>
                            <span className="font-semibold">12.3.</span> A los efectos del presente, se entenderá como
                            Información Confidencial toda aquella divulgada por una Parte a la otra, por cualquier
                            medio, incluyendo —sin limitación—: métodos, procedimientos, manuales, tutoriales,
                            información tecnológica, propiedad intelectual, secretos comerciales, datos contables,
                            financieros, fiscales, de clientes, así como cualquier otra información relativa a las
                            actividades de QUADMINDS, sus afiliadas o del Cliente.
                        </p>
                        <div>
                            <h3 className="text-xs font-semibold mb-1">
                                12.4. Las obligaciones de confidencialidad no serán aplicables respecto de información
                                que:
                            </h3>
                            <ul className="list-none pl-4 space-y-2">
                                <li>a) sea o se haga pública sin infracción a esta cláusula;</li>
                                <li>b) obre legítimamente en poder de la Parte receptora antes de su divulgación;</li>
                                <li>
                                    c) sea obtenida de forma legítima de un tercero con derecho a divulgarla sin
                                    restricciones; o
                                </li>
                                <li>
                                    d) deba ser revelada en virtud de exigencia legal o de orden de autoridad
                                    competente, en cuyo caso la Parte Receptora notificará a la Parte Reveladora dentro
                                    de las 24 (veinticuatro) horas siguientes, siempre que ello sea legalmente posible.
                                </li>
                            </ul>
                        </div>
                        <p>
                            <span className="font-semibold">12.5.</span> Las obligaciones de confidencialidad
                            establecidas en esta cláusula permanecerán vigentes durante la vigencia de los presentes
                            Términos y por un período adicional de dos (2) años a partir de su terminación, cualquiera
                            sea la causa.
                        </p>
                    </div>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">13. MODIFICACIONES A LOS TÉRMINOS.</h2>
                    <p>
                        QUADMINDS podrá modificar los presentes Términos en cualquier momento. Las nuevas versiones
                        serán debidamente notificadas mediante su publicación en la plataforma Mindy y, adicionalmente,
                        podrán ser notificadas a través de los medios de contacto declarados por el Cliente.
                    </p>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">14. SUSPENSIÓN Y TERMINACIÓN.</h2>
                    <p>
                        QUADMINDS podrá suspender temporalmente o cancelar permanentemente el acceso del Cliente a Mindy
                        en caso de incumplimiento de los presentes Términos, o por cualquier otra razón justificada, sin
                        previo aviso. Asimismo, QUADMINDS podrá ejercer dicha facultad en caso de terminación de la
                        relación contractual entre QUADMINDS y el Cliente, o en caso de que QUADMINDS decida finalizar
                        el período de prueba, de corresponder.
                    </p>
                </section>

                <section>
                    <h2 className="text-xs font-bold mb-2">15. LEY APLICABLE Y JURISDICCIÓN.</h2>
                    <p>
                        Los presentes Términos, así como la relación entre QUADMINDS y el Cliente, se regirán e
                        interpretarán con arreglo a la legislación vigente en Argentina y, en caso de controversia, las
                        Partes acuerdan someterse a la jurisdicción de los Tribunales Ordinarios de la Ciudad Autónoma
                        de Buenos Aires.
                    </p>
                </section>
            </main>
        </>
    );
};
